import { ref, computed } from 'vue';
import { passengersCounterConfig } from './config';
import { passengerCounterLib } from './lib';
import type { PassengersList } from './types';

export function usePassengersCounter({
  initialPassengers,
}: {
  initialPassengers: PassengersList | null;
}) {
  const initialState =
    initialPassengers || passengersCounterConfig.DEFAULT_PASSENGERS_STATE;
  const passengersList = ref(initialState);
  const state = computed(() =>
    passengerCounterLib.getPassengersCounterState(passengersList.value),
  );

  function updatePassengers(payload: Partial<PassengersList>) {
    passengersList.value = passengerCounterLib.shouldInfantsDecrease(
      payload.adt,
      passengersList.value.inf,
    )
      ? ({
          ...passengersList.value,
          ...payload,
          inf: payload.adt,
        } as PassengersList)
      : { ...passengersList.value, ...payload };
  }

  return {
    state,
    passengersList,
    updatePassengers,
  };
}
